import VehicleCoverage from 'models/VehicleCoverage'
import { PhysicalPerson } from 'models/Person'
import Insured from 'models/Insured'
import CarAsset from 'models/CarAsset'
import ShowDataItem from 'models/ShowDataItem'

class PolicyEntity {
    constructor(
        id,
        insuranceCompany,
        insuranceCompanyName,
        multiQuoteType,
        policyStatus,
        proposal,
        title,
        subtitle,
        risks,
        amendments,
        companyLogo,
        smallCompanyLogo,
        downloadDocuments,
        validTo,
        policyId,
        canDelete,
        canModify,
        editableData,
        origin,
        missingInspection,
        canCreateQuoteFromPolicy,
        locality,
        commissionType,
        parentPolicyId
    ) {
        this.id = id
        this.insuranceCompany = insuranceCompany
        this.insuranceCompanyName = insuranceCompanyName
        this.multiQuoteType = multiQuoteType
        this.proposal = proposal
        this.title = title
        this.subtitle = subtitle
        this.risks = risks
        this.amendments = amendments
        this.companyLogo = companyLogo
        this.smallCompanyLogo = smallCompanyLogo
        this.downloadDocuments = downloadDocuments
        this.validTo = validTo
        this.policyId = policyId
        this.canDelete = canDelete
        this.canModify = canModify
        this.editableData = editableData
        this.origin = origin
        this.missingInspection = missingInspection
        this.canCreateQuoteFromPolicy = canCreateQuoteFromPolicy
        this.locality = locality
        this.commissionType = commissionType
        this.parentPolicyId = parentPolicyId
    }

    setAsset(asset) {
        this.asset = asset
    }

    setCoverage(coverage) {
        this.coverage = coverage
    }

    setCustomer(customer) {
        this.customer = customer
    }

    setInsured(insured) {
        this.insured = insured
    }

    showAssetData(assetData) {
        const formattedData = []
        Object.keys(assetData).forEach((key) => {
            formattedData.push(ShowDataItem.fromJson({ key, value: assetData[key] }))
        })
        this.showAssetData = formattedData
    }

    showInsuranceData(insuranceData) {
        const formattedData = []
        Object.keys(insuranceData).forEach((key) => {
            formattedData.push(ShowDataItem.fromJson({ key, value: insuranceData[key] }))
        })
        this.showInsuranceData = formattedData
    }

    showPaymentData(paymentData) {
        const formattedData = []
        Object.keys(paymentData).forEach((key) => {
            formattedData.push(ShowDataItem.fromJson({ key, value: paymentData[key] }))
        })
        this.showPaymentData = formattedData
    }

    showPolicyData(policyData) {
        const formattedData = []
        Object.keys(policyData).forEach((key) => {
            formattedData.push(ShowDataItem.fromJson({ key, value: policyData[key] }))
        })
        this.showPolicyData = formattedData
    }

    static fromJson({
        id,
        asset,
        coverage,
        customer,
        insuranceCompany,
        insured,
        multiQuoteType,
        policyStatus,
        proposal,
        subtitle,
        title,
        showAssetData,
        showInsuranceData,
        showPaymentData,
        showPolicyData,
        risks,
        amendments,
        insuranceCompanyLogos,
        downloadDocuments,
        validTo,
        policyId,
        canDelete,
        canModify,
        editableData,
        origin,
        missingInspection,
        canCreateQuoteFromPolicy,
        locality,
        commissionType,
        parentPolicyId,
    }) {
        const policyEntity = new PolicyEntity(
            id,
            insuranceCompany,
            insuranceCompanyLogos?.displayLongName,
            multiQuoteType,
            policyStatus,
            proposal,
            title,
            subtitle,
            risks,
            amendments,
            insuranceCompanyLogos.logo,
            insuranceCompanyLogos.small,
            downloadDocuments,
            validTo,
            policyId,
            canDelete,
            canModify,
            editableData,
            origin,
            missingInspection,
            canCreateQuoteFromPolicy,
            locality,
            commissionType,
            parentPolicyId
        )
        if (asset) {
            policyEntity.setAsset(CarAsset.fromJson(asset))
        }
        policyEntity.setCoverage(VehicleCoverage.fromJson(coverage))
        policyEntity.setCustomer(PhysicalPerson.fromJson(customer))
        if (insured) {
            policyEntity.setInsured(Insured.fromJson(insured))
        }
        policyEntity.showAssetData(showAssetData)
        policyEntity.showInsuranceData(showInsuranceData)
        policyEntity.showPaymentData(showPaymentData)
        policyEntity.showPolicyData(showPolicyData)
        return policyEntity
    }
}

export default PolicyEntity
